/* eslint-disable no-nested-ternary */
import Date from 'components/Date';
import Dropdown from 'components/Dropdown';
import { Calendar, CaretDownIcon, CheckIcon } from 'components/icons';
import Dropdownbody, {
  stylesForDropDown,
} from 'components/Dropdown/dropdownbody';
import {
  getDateForYesterday,
  getFirstDayOfLastWeek,
  getFirstDayOfThisWeek,
  getLastDayOfThisWeek,
  getLastDayOfLastWeek,
  getFirstDayOfThisMonth,
  getStartOfLast3Month,
  getEndOfLast3Month,
  getFirstDayOfThisQuarter,
  getLastDayOfThisQuarter,
  getFirstDayOfYear,
  getLastDayOfYear,
  getEndOfThisMonth,
  formatDateForView,
  getStartOfToday,
  getEndOfToday,
  getDateFromBeginning,
} from 'libs';
import React from 'react';
import classname from 'classname';
import { globalStyles } from 'styles';
import styles from './datefilter.module.scss';

export default function DateFilter({
  date,
  defaultValue = 'thismonth',
  setDate,
  showBorder,
}) {
  const [filter, setFilter] = React.useState(defaultValue);
  const [showCustom, setShowCustom] = React.useState(filter === 'custom');
  const [showCustomDate, setShowCustomDate] = React.useState(false);
  const [filterDropdownOpen, setFilterDropdownOpen] = React.useState(false);

  const dateMapping = {
    allTime: {
      from: getDateFromBeginning(),
      to: getEndOfToday(),
    },
    all: {
      from: getStartOfToday(),
      to: getEndOfToday(),
    },
    yesterday: {
      from: getDateForYesterday(),
      to: getDateForYesterday(),
    },
    thisweek: {
      from: getFirstDayOfThisWeek(),
      to: getLastDayOfThisWeek(),
    },
    lastweek: {
      from: getFirstDayOfLastWeek(),
      to: getLastDayOfLastWeek(),
    },
    thismonth: {
      from: getFirstDayOfThisMonth(),
      to: getEndOfThisMonth(),
    },
    past3months: {
      from: getStartOfLast3Month(),
      to: getEndOfLast3Month(),
    },
    thisquarter: {
      from: getFirstDayOfThisQuarter(),
      to: getLastDayOfThisQuarter(),
    },
    thisyear: {
      from: getFirstDayOfYear(),
      to: getLastDayOfYear(),
    },
  };

  const filterOptions = [
    {
      label: 'Today',
      value: 'all',
    },
    {
      label: 'Yesterday',
      value: 'yesterday',
    },
    {
      label: 'This Week',
      value: 'thisweek',
    },
    {
      label: 'Last Week',
      value: 'lastweek',
    },
    {
      label: 'This Month',
      value: 'thismonth',
    },
    {
      label: 'Past 3 Months',
      value: 'past3months',
    },
    {
      label: 'This Quarter',
      value: 'thisquarter',
    },
    {
      label: 'This Year',
      value: 'thisyear',
    },
    {
      label: 'All Time',
      value: 'allTime',
    },
    {
      label: 'Custom',
      value: 'custom',
    },
  ];
  const filterValueLabelMapping = filterOptions.reduce(
    (acc, { label, value }) => {
      acc[value] = label;
      return acc;
    },
    {},
  );
  const showDate = (date) => formatDateForView(date);

  React.useEffect(() => {
    if (filter === 'custom') {
      setDate({ from: '', to: '' });
      setShowCustomDate(true);
      return;
    }
    setDate({
      from: showDate(dateMapping[filter].from),
      to: showDate(dateMapping[filter].to),
    });
    setShowCustom(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter]);
  const handleFilterChange = (value) => {
    if (filter === 'custom' && value === 'custom') {
      setDate({ from: '', to: '' });
      setShowCustomDate(true);
      setFilterDropdownOpen(false);
      return;
    }
    setFilter(value);
    setFilterDropdownOpen(false);
  };
  return (
    <div
      className={classname(
        globalStyles.flex,
        globalStyles.alignItemsCenter,
        globalStyles.flexWrap,
      )}
      data-testid="date-filter"
    >
      <p style={{ marginRight: '8px', fontWeight: '600' }}>Filter by: </p>
      <Dropdown
        header={
          <div
            className={classname(
              showBorder ? styles.border : '',
              styles.filter,
            )}
          >
            <Calendar />
            {filter === 'allTime' ? (
              <div className={styles.showDate}>
                <p>All Time</p>
              </div>
            ) : date.from ? (
              <div className={styles.showDate}>
                <p>{showDate(date.from)}</p>
                <p> &nbsp; - {showDate(date.to)}</p>
              </div>
            ) : null}
            <CaretDownIcon fill="#18379A" style={{ marginLeft: 'auto' }} />
          </div>
        }
        isOpen={filterDropdownOpen}
        setIsOpen={setFilterDropdownOpen}
      >
        <Dropdownbody>
          {filterOptions.map(({ label, value }) => (
            <button
              key={label}
              className={classname(
                globalStyles.flex,
                globalStyles.alignItemsCenter,
                stylesForDropDown.dropdownitem,
              )}
              onClick={() => handleFilterChange(value)}
            >
              <Calendar style={{ marginRight: '8px' }} />
              <p className={stylesForDropDown.dropdownitemtext}>{label}</p>
              {filterValueLabelMapping[filter] === label && (
                <CheckIcon style={{ marginLeft: 'auto' }} />
              )}
            </button>
          ))}
        </Dropdownbody>
      </Dropdown>
      <Dropdown
        isOpen={showCustomDate}
        setIsOpen={setShowCustomDate}
        style={{ minWidth: '270px' }}
        header={<div />}
      >
        <Date
          date={date}
          setDate={setDate}
          handleClose={() => {
            setShowCustomDate(false);
            handleFilterChange('all');
          }}
        />
      </Dropdown>
    </div>
  );
}
